<template>
  <div class="search-result">
    <div v-if="status === 'loading'" class="loading-section">
      <Loading />
    </div>
    <div v-else class="search-result__loaded">
      <div v-if="items.length > 0">
        <div class="search-result__items">
          <ItemBoxesConnected
            :items="items"
            :three-columns="threeColumns"
            :rank-offset="(currentPage - 1) * ITEMS_PER_PAGE"
            price-suffix="など"
            @click-item-boxes-connected="onClickItem"
          />
        </div>
        <div class="search-result__pagination">
          <Pagination
            class="pagination"
            :current-page="currentPage"
            :total-pages="totalPages"
            @clicked="emit('change-page', $event)"
          />
        </div>
      </div>
      <div v-else-if="hasFinished" class="empty-result">
        <div class="body">条件に一致するギフトは見つかりませんでした</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Pagination from '../../components/organism/paginations/Pagination.vue'
import ItemBoxesConnected from '../../components/molecules/item_boxes/ItemBoxesConnected.vue'
import Loading from '../../components/atoms/loadings/Loading.vue'
import { ITEMS_PER_PAGE } from '../../constants/itemSearchConstatnts.js'

const props = defineProps({
  items: { type: Array, required: true },
  status: { type: String, required: true },
  currentPage: { type: Number, required: true },
  totalPages: { type: Number, required: true },
  // FIXME(item_list_three_columns): ABテスト決着後、threeColumnsの分岐を削除する
  threeColumns: { type: Boolean, required: false, default: false }
})
const emit = defineEmits(['click-item', 'change-page'])
const onClickItem = (itemId, rank) =>
  emit(
    'click-item',
    props.items.find(item => item.id === itemId),
    rank
  )
// 通信失敗時も「結果なし」を表示する。
const hasFinished = computed(() => ['success', 'error'].includes(props.status))
</script>

<style lang="scss" scoped>
.search-result {
  &__items {
    margin-bottom: 16px;
    background-color: $white;

    @media all and (max-width: ($base-contents-width - 1)) {
      margin-bottom: 1px;
    }
  }

  &__pagination {
    margin-bottom: 16px;
    background-color: $gray-3;

    @media all and (max-width: ($base-contents-width - 1)) {
      background-color: $white;
    }

    .pagination {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .item-boxes--connected {
    // bodyから継承する中央揃えを解除する。
    text-align: left;
    justify-content: center;
    max-width: $max-contents-width;
    margin: 0 auto;
  }

  .loading-section {
    text-align: center;
    background-color: $white;
    height: 29px;
    padding-top: 52px;
    padding-bottom: 40px;
  }

  .empty-result {
    background-color: $white;
    padding-top: 64px;
    padding-bottom: 64px;
  }
}
</style>
